function getPriceForVenue(prices){
  const venue = get_current_venue_info();
  const venueId = venue.id;
  let venuePrice = null;

  if(typeof prices == 'object'){
    for(const details of prices){
      if(details.venue == venueId){
        venuePrice = details.price;
      }
    }
  }

  return venuePrice;
}

function getIsLocalProduct(prices){
  const venue = get_current_venue_info();
  const venueId = venue.id;
  let localProduct = false;

  if(typeof prices == 'object'){
    for(const details of prices){
      if(details.venue == venueId){
        if(details.local){
          localProduct = true;
        }
      }
    }
  }

  return localProduct;
}

function updatePrice(prices, price, group, container){
  const venuePrice = getPriceForVenue(prices);

  if(venuePrice && venuePrice !== '0'){
    if(price) {
      price.innerText = venuePrice;
    }
    if(group) {
      group.classList.remove('hidden!');
      group.removeAttribute('inert');
    }
    if(container) {
      container.classList.remove('hidden!');
      container.removeAttribute('inert');
    }
  }else{
    if(price) {
      price.innerText = '';
    }
    if(group) {
      group.classList.add('hidden!');
      group.setAttribute('inert', '');
    }
    if(container) {
      container.classList.add('hidden!');
      container.setAttribute('inert', '');
    }
  }
}

function updateLocalBadge(display, element){
  if(display){
    if(element) {
      element.classList.remove('hidden!');
      element.removeAttribute('inert');
    }
  }else{
    if(element) {
      element.classList.add('hidden!');
      element.setAttribute('inert', '');
    }
  }
}

function updateCharacteristics(characteristic, item){
  if(!characteristic) return;

  const itemCharacteristics = item.dataset.characteristics?.split(',');

  if(!itemCharacteristics || !itemCharacteristics?.includes(characteristic)){
    item.classList.add('hidden!');
    item.setAttribute('inert', '');

    const container = item.closest('[data-price-container]');
    if(container) {
      container.classList.add('hidden!');
      container.setAttribute('inert', '[data-price-container]');
    }
  }
}

function setPrices() {
  if(!get_current_venue_info()){
    setTimeout(setPrices, 1000);
    return;
  }

  document.querySelectorAll('[data-menu-item]').forEach((item) => {
    item.querySelectorAll('[data-local]').forEach((conditionalElement) => {
      const prices = JSON.parse(conditionalElement.dataset.local);
      const isLocal = getIsLocalProduct(prices);
      updateLocalBadge(isLocal, conditionalElement);
    });

    item.querySelectorAll('[data-price]').forEach((conditionalElement) => {
      const prices = JSON.parse(conditionalElement.dataset.price);
      const price = conditionalElement.hasAttribute('data-price-display') ? conditionalElement : null;
      const group = conditionalElement.closest('[data-price-group]');
      const container = conditionalElement.closest('[data-price-container]');
      updatePrice(prices, price, group, container);
    });

    if(window.menu_characteristics){
      updateCharacteristics(window.menu_characteristics, item);
    }
  });
}

setPrices();
document.body.addEventListener('venueChanged', setPrices);


document.querySelectorAll('.menu-item-image-toggle').forEach((button) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    e.target.closest('.menu-item').querySelector('.menu-item-image').classList.toggle('open');
  })
});